<template>
  <QS-scroller-box>
    <EchoLastData :dataList="masterOrderSignPreview" :model="renderData.model.topPreviewModel">
    </EchoLastData>
    <div class="tip">提示：录入的租赁车辆仅作记录，不会在子订单中创建支付项</div>
    <form-text-box :column="2" :dataList="renderData.list.orderSignFormList" :model="renderData.model.orderSignModel"
      :rules="renderData.rules.orderSignRules" />
    <template slot="bottomAction">
      <el-button @click="cancel" size="mini">取消</el-button>
      <el-button @click="previousStep" size="mini">上一步</el-button>
      <el-button @click="confirm" size="mini" type="primary">确认，下一步</el-button>
    </template>
  </QS-scroller-box>
</template>
<script>
import moment from 'moment'
import EchoLastData from '../../../components/EchoLastData.vue'
import { masterOrderSignPreview } from '../../config/echoLastData'

export default {
  components: {
    EchoLastData,
  },
  props: {
    renderData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      masterOrderSignPreview,
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    previousStep() {
      this.$emit('previousStep')
    },
    confirm() {
      const { contractNo, contractAttachment } = this.renderData.model.orderSignModel
      if (!contractNo) {
        this.$message.error('请填写业务合同编号')
        return
      }
      if (!contractAttachment) {
        this.$message.error('请上传合同附件')
        return
      }
      this.handelToppreview()
      this.$emit('confirm')
    },
    handelToppreview() {
      const { contractDate, carTotalNum } = this.renderData.model.orderSignModel
      const [startTime, endTime] = contractDate
      if (startTime && endTime) {
        // 合同起止时间
        // eslint-disable-next-line vue/no-mutating-props
        this.renderData.model.topPreviewModel.contractDate = `${moment(startTime).format('YYYY-MM-DD')} 至 ${moment(endTime).format('YYYY-MM-DD')}`
      }
      // 租赁车辆数
      // eslint-disable-next-line vue/no-mutating-props
      this.renderData.model.topPreviewModel.carTotalNum = carTotalNum
    },
  },
}
</script>
<style scoped lang='scss'>
.tip {
  margin: 20px 0;
  background: #f7f8fa;
  color: #898a8a;
  padding: 5px;
  font-weight: bold;
}
</style>
